// @ts-nocheck
/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import { LayoutItem, Text, TextLink } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import {
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_350,
  SYS_SPACE_FIXED_150,
} from '@oneaudi/unified-web-common';
import searchStateContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import PartnerBusinessCardLoader from '../PartnerBusinessCard/PartnerBusinessCardLoader';
import SpacingContainer from '../../common/SpacingContainer/SpacingContainer';
import { messages } from '../../../i18n/messages';
import { DesktopFlyout } from '../Flyout/DesktopFlyout';
import { attachFocusTrap } from '../../../utils/focusTrap';

type Props = {
  dealerId: string;
  favoritePartner: {
    kvpsid: string;
    tenant: string;
  };
};
export default function DesktopDealerDetails({ dealerId, favoritePartner }: Props) {
  const { dealerRatings, showComments } = searchStateContext.useMapState();

  const fiveStarRating = dealerRatings?.[dealerId];

  const dispatch = searchStateContext.useMapDispatch();

  const closeDealerDetail = () => {
    dispatch({ type: ActionTypes.setSelectedDealerId, payload: null });
    dispatch({ type: ActionTypes.setDealerReviews, payload: [] });
    dispatch({ type: ActionTypes.setRatingSummary, payload: null });
  };

  const ensureNoScrollLockForFlyout = () => {
    if (document.getElementById('no-scroll-lock-style')) return;

    const style = document.createElement('style');
    style.id = 'no-scroll-lock-style';
    style.textContent = `
    body:has(#fiveStarFlyout[open]) {
      overflow: auto !important;
    }
  `;
    document.head.appendChild(style);
  };

  const openDialog = () => {
    ensureNoScrollLockForFlyout();
    const dialog = document.getElementById('fiveStarFlyout') as HTMLDialogElement;
    const anchor = document.getElementById('desktopMap');
    const backdrop = document.getElementById('fiveStarFlyoutBackdrop');

    if (!anchor || !dialog || !backdrop) return;

    // Now we know all elements exist, safe to use dialog as HTMLDialogElement
    const rect = anchor.getBoundingClientRect();
    const left = `${rect.left}px`;
    if (showComments) {
      dialog.style.left = left;
    }
    dialog.style.visibility = 'visible';
    backdrop.style.display = 'block';

    dialog.show();
    attachFocusTrap(dialog, {
      onEscape: () => {
        dialog.close();
        dialog.style.visibility = 'hidden';
        backdrop.style.display = 'none';
      },
    });
  };

  return (
    <DealerDetailsContainer data-test-id="dealer-details">
      <DesktopFlyout data-test-id="component-desktop-flyout" />

      <SpacingContainer style={{ margin: SYS_SPACE_FIXED_350 }}>
        <BackToResultsButton
          variant="standalone"
          icon="back"
          iconPosition="leading"
          onClick={closeDealerDetail}
          data-test-id="dealer-details-cancel-button"
          aria-label="close dealer details"
          size="md"
        >
          {useI18n(messages.back_to_results)}
        </BackToResultsButton>
        <LayoutItem align="center">
          <Text tag="span" variant={{ order: '3', type: 'copy', style: 'normal' }}>
            {useI18n(messages.partner_details)}
          </Text>
        </LayoutItem>
        <PartnerBusinessCardLoader
          partnerID={dealerId}
          fiveStarRating={fiveStarRating}
          isMobile={false}
          favoritePartner={favoritePartner}
          openDialog={openDialog}
        />
      </SpacingContainer>
    </DealerDetailsContainer>
  );
}

const DealerDetailsContainer = styled.div`
  width: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 7px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 4px;
  }
`;

const BackToResultsButton = styled(TextLink)`
  min-height: auto;
  padding: 0;
  text-decoration: none;
  margin: ${SYS_SPACE_FIXED_200} 0;
  svg {
    margin-right: ${SYS_SPACE_FIXED_150};
  }
`;
